import { FtlRouteViewModel } from "../../../../ViewModel/FtlRouteViewModel";

export function setInboundOdcLoadType(
  ftlRoutes: Array<FtlRouteViewModel>,
  ftlRouteNumber: string | undefined,
  spdrId: number,
  myField: string,
  loadType: string
) {
  return ftlRoutes?.map((ftlRoute) => {
    if (ftlRoute.RouteNumber !== ftlRouteNumber) {
      return ftlRoute;
    }

    return {
      ...ftlRoute,
      SpdrsOnThisRoute: ftlRoute.SpdrsOnThisRoute?.map((spdr) => {
        if (spdr.SpdrId !== spdrId) {
          return spdr;
        }

        return {
          ...spdr,
          ODCs: spdr.ODCs?.map((odcItem) => {
            if (odcItem.OdcGsdb !== myField) {
              return odcItem;
            }
            return {
              ...odcItem,
              LoadType: loadType,
            };
          }),
        };
      }),
    };
  });
}
